export default "__VITE_ASSET__BP5KPF7K__"